import { render, staticRenderFns } from "./editPersonCenter.vue?vue&type=template&id=102b60f9&scoped=true&"
import script from "./editPersonCenter.vue?vue&type=script&lang=js&"
export * from "./editPersonCenter.vue?vue&type=script&lang=js&"
import style0 from "./editPersonCenter.vue?vue&type=style&index=0&id=102b60f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102b60f9",
  null
  
)

export default component.exports